import { apiFetch, apiUrl, type ApiResponse } from "./fetch";

type ImageUploadDto = {
	url: string;
};

export const postApiFilesImages = async (file: File): Promise<string> => {
	const formData = new FormData();
	formData.append("file", file);
	const response = await apiFetch<ApiResponse<ImageUploadDto>>({
		body: formData,
		method: "POST",
		uri: "files/images",
	});
	if (response.error !== null || response.data === null) {
		throw new Error(response.error?.message ?? "Не удалось загрузить изображение.");
	}
	return apiUrl(response.data.url).toString();
};
